(function (angular) {
    'use strict';

    angular.module('integration')

        /**
         *
         */
        .factory('webhooksService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    // urlBase = 'http://localhost:8001';
                    var fac = {
                        getAvailableEvents: getAvailableEvents,
                        getAvailableTemplates: getAvailableTemplates,
                        getWebhooks: getWebhooks,
                        getWebhook: getWebhook,
                        getWebhookFailures: getWebhookFailures,
                        getLastWebhookSuccess: getLastWebhookSuccess,
                        createWebhook: createWebhook,
                        updateWebhook: updateWebhook,
                        enableWebhook: enableWebhook,
                        disableWebhook: disableWebhook,
                        deleteWebhook: deleteWebhook
                    };

                    return fac;

                    /**
                     * GET "/apispaces/{id}/webhooks/availableevents"
                     * @param {string} id - the api space Id
                     */
                    function getAvailableEvents(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/webhooks/availableevents")
                            .then(getAvailableEventsComplete)
                            .catch(getAvailableEventsFailed);

                        function getAvailableEventsComplete(response) {
                            return response.data;
                        }

                        function getAvailableEventsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispace/{id}/webhooks/availabletemplates"
                     * @param {string} id - the api space Id
                     */
                    function getAvailableTemplates(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/webhooks/availabletemplates")
                            .then(getAvailableTemplatesComplete)
                            .catch(getAvailableTemplatesFailed);

                        function getAvailableTemplatesComplete(response) {
                            return response.data;
                        }

                        function getAvailableTemplatesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }


                    /**
                     * GET "/apispaces/{id}/webhooks"
                     * @param {string} id - the api space Id
                     */
                    function getWebhooks(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/webhooks")
                            .then(getWebhooksComplete)
                            .catch(getWebhooksFailed);

                        function getWebhooksComplete(response) {
                            return response.data;
                        }

                        function getWebhooksFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{id}/webhooks/{webhookId}"
                     * @param {string} id - the api space Id
                     * @param {string} webhookId - the webhook id
                     */
                    function getWebhook(id, webhookId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(webhookId))
                            .then(getWebhookComplete)
                            .catch(getWebhookFailed);

                        function getWebhookComplete(response) {
                            return response.data;
                        }

                        function getWebhookFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function getWebhookFailures(id, webhookId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(webhookId) + "/failures")
                            .then(getFailuresComplete)
                            .catch(getFailuresFailed);

                        function getFailuresComplete(response) {
                            return response.data;
                        }

                        function getFailuresFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getLastWebhookSuccess(id, webhookId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(webhookId) + "/lastsuccess")
                            .then(getSuccessCompleted)
                            .catch(getSuccessFailed);

                        function getSuccessCompleted(response) {
                            return response.data;
                        }

                        function getSuccessFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * POST "/apispaces/{id}/webhooks"
                     * @param {string} id - the api space Id
                     * @param {object} data - the webhook data
                     */
                    function createWebhook(id, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/webhooks", data)
                            .then(getWebhookComplete)
                            .catch(getWebhookFailed);

                        function getWebhookComplete(response) {
                            return response.data;
                        }

                        function getWebhookFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * PUT "/apispaces/{id}/webhooks"
                     * @param {string} id - the api space Id
                     * @param {object} data - the webhook data
                     */
                    function updateWebhook(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(data.id), data)
                            .then(updateWebhookComplete)
                            .catch(updateWebhookFailed);

                        function updateWebhookComplete(response) {
                            return response.data;
                        }

                        function updateWebhookFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * PUT "/apispaces/{id}/webhooks/{webhookId}/enable"
                     * @param {string} id - the api space Id
                     * @param {object} webhookId - the webhook id
                     */
                    function enableWebhook(id, webhookId) {

                        return $http.put(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(webhookId) + "/enable")
                            .then(enableWebhookComplete)
                            .catch(enableWebhookFailed);

                        function enableWebhookComplete(response) {
                            return response.data;
                        }

                        function enableWebhookFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PUT "/apispaces/{id}/webhooks/{webhookId}/disable"
                     * @param {string} id - the api space Id
                     * @param {object} webhookId - the webhook id
                     */
                    function disableWebhook(id, webhookId) {

                        return $http.put(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(webhookId) + "/disable")
                            .then(disableWebhookComplete)
                            .catch(disableWebhookFailed);

                        function disableWebhookComplete(response) {
                            return response.data;
                        }

                        function disableWebhookFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * DELETE "/apispaces/{id}/webhooks"
                     * @param {string} id - the api space Id
                     * @param {string} webhookId - the webhook id
                     */
                    function deleteWebhook(id, webhookId) {
                        return $http.delete(urlBase + "/apispaces/" + id + "/webhooks/" + encodeURIComponent(webhookId))
                            .then(deleteWebhookComplete)
                            .catch(deleteWebhookFailed);

                        function deleteWebhookComplete(response) {
                            return response.data;
                        }

                        function deleteWebhookFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);
